import { API_URL } from 'config'

const defaultHeaders = {
  accept: 'application/json',
  'content-type': 'application/json'
}

export function setTokenHeader(value) {
  defaultHeaders['Authorization'] = value
}

export function clearTokenHeader() {
  delete defaultHeaders['Authorization']
}

const buildRequestError = (res, body) => {
  const fallbackMessage =
    res.status === 401 ? 'Unauthorized' : res.status === 403 ? 'Forbidden' : res.statusText
  const error = new Error(body?.message || fallbackMessage)

  error.status = res.status
  error.statusText = res.statusText
  error.responseBody = body

  if (body?.errorCode) {
    error.errorCode = body.errorCode
  }

  return error
}

export default function request(path, args = {}) {
  const url = `${API_URL}/${path}`

  const options = {
    headers: args.headers || defaultHeaders,
    method: args.method || 'GET'
  }

  if (args.data) {
    options.body = JSON.stringify(args.data)
    options.headers['content-type'] = 'application/json'
  }
  const allowStatuses = args.allowStatuses || []
  return fetch(url, options)
    .then(async res => {
      if (res.status >= 200 && res.status < 300) {
        return res
      }

      if (allowStatuses.includes(res.status)) {
        return res
      }

      return res
        .json()
        .catch(() => null)
        .then(body => {
          throw buildRequestError(res, body)
        })
    })
    .then(res => {
      // Some callers assume every successful request resolves to the same [body, response] array shape.
      // A 204 has no JSON body, but it is still a successful "empty result" response, so we
      // normalize it to [null, response] instead of returning the raw Response object.
      //
      // Long term, this request layer should move away from this array-based response shape and expose
      // a clearer named shape (for example { data, response }) for all successful requests.
      if (res.status === 204) {
        return [null, res]
      }

      return res.json().then(body => [body, res])
    })
}

export function requestFile(path, args = {}) {
  const url = `${API_URL}/${path}`

  const options = {
    headers: args.headers || defaultHeaders,
    method: args.method || 'GET'
  }

  if (args.data) {
    options.body = JSON.stringify(args.data)
    options.headers['content-type'] = 'application/json'
  }
  return fetch(url, options).then(res => {
    if (res.status >= 200 && res.status < 300) {
      return res
    }
  })
}
